import { type GridPosition, type SelectionRange } from '../../../../state/types.ts';
import { type SelectionAxis } from '../../../types.ts';
import { getRangeMinMax } from '../../range/get-range-min-max.ts';

export function closestBeforeSelectedPosition(
  selections: SelectionRange[],
  axis: SelectionAxis,
  deselectedIndex: number
): GridPosition | null {
  let bestBefore = -1;
  let bestAfter = Infinity;

  for (const r of selections) {
    const { min, max } = getRangeMinMax(r, axis);
    if (max < deselectedIndex) {
      bestBefore = Math.max(bestBefore, max);
    } else if (min < deselectedIndex) {
      bestBefore = Math.max(bestBefore, deselectedIndex - 1);
    }
    if (min > deselectedIndex) {
      bestAfter = Math.min(bestAfter, min);
    } else if (max > deselectedIndex) {
      bestAfter = Math.min(bestAfter, deselectedIndex + 1);
    }
  }

  if (bestBefore < 0 && bestAfter === Infinity) {
    return null;
  }

  const index = bestBefore >= 0 ? bestBefore : bestAfter;
  return axis === 'row'
    ? { row: { index }, col: { index: 0 } }
    : { row: { index: 0 }, col: { index } };
}
